import { render, staticRenderFns } from "./TemporaryPassword.vue?vue&type=template&id=18542700&scoped=true&"
import script from "./TemporaryPassword.vue?vue&type=script&lang=ts&"
export * from "./TemporaryPassword.vue?vue&type=script&lang=ts&"
import style0 from "./TemporaryPassword.vue?vue&type=style&index=0&id=18542700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18542700",
  null
  
)

export default component.exports